export var FormStage;
(function (FormStage) {
    FormStage[FormStage["PaymentType"] = 0] = "PaymentType";
    FormStage[FormStage["MembershipType"] = 1] = "MembershipType";
    FormStage[FormStage["Membership"] = 2] = "Membership";
})(FormStage || (FormStage = {}));
